module.exports = __webpack_public_path__ + "images/MyCard19b3b358343d38b0d3abf59b26feb5354.jpg";